import React from 'react';

import ProductListPageSkeleton from '../../components/skeleton/ProductListPageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const ON_SALE_PAGE_CHUNK_NAME = 'onSalePage';

export const OnSalePage = createRouteLoadable(
  () => import(/* webpackChunkName: "onSalePage" */ '../../pages/OnSalePage'),
  {
    fallback: <ProductListPageSkeleton variant="onSale" />,
  }
);

export const NEW_PRODUCTS_PAGE_CHUNK_NAME = 'newProductsPage';

export const NewProductsPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "newProductsPage" */ '../../pages/NewProductsPage'
    ),
  {
    fallback: <ProductListPageSkeleton variant="newProducts" />,
  }
);

export const SOLD_PRODUCTS_PAGE_CHUNK_NAME = 'soldProductsPage';

export const SoldProductsPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "soldProductsPage" */ '../../pages/SoldProductsPage'
    ),
  {
    fallback: <ProductListPageSkeleton variant="soldProducts" />,
  }
);

export const POPULAR_PRODUCTS_PAGE_CHUNK_NAME = 'popularProductsPage';

export const PopularProductsPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "popularProductsPage" */ '../../pages/PopularProductsPage'
    ),
  {
    fallback: <ProductListPageSkeleton variant="popularProducts" />,
  }
);

export const RECOMMENDED_PRODUCTS_PAGE_CHUNK_NAME = 'recommendedProductsPage';

export const RecommendedProductsPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "recommendedProductsPage" */ '../../pages/RecommendedProductsPage'
    ),
  {
    fallback: <ProductListPageSkeleton variant="recommendedProducts" />,
  }
);
